import { gql } from '@apollo/client';

export const GET_PROJECT_STATUS = gql`
  query GET_PROJECT_STATUS($ids: [ID!], $state: State) {
    projectStatus(ids: $ids, state: $state) {
      id
      name
      seq
      description
      controlType
      disabled
    }
  }
`;

export const ADD_PROJECT_STATUS = gql`
  mutation ADD_PROJECT_STATUS($input: ProjectStatusInput!) {
    addProjectStatus(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_PROJECT_STATUS = gql`
  mutation UPDATE_PROJECT_STATUS($id: ID!, $input: ProjectStatusInput!) {
    updateProjectStatus(id: $id, input: $input) {
      id
      name
    }
  }
`;

export const DELETE_PROJECT_STATUS = gql`
  mutation DELETE_PROJECT_STATUS($id: ID!) {
    deleteProjectStatus(id: $id) {
      id
      name
    }
  }
`;

export const TOGGLE_DISABLED_PROJECT_STATUS = gql`
  mutation TOGGLE_DISABLED_PROJECT_STATUS($id: ID!) {
    toggleDisabledProjectStatus(id: $id) {
      id
    }
  }
`;
